import { useQuery } from '@apollo/client';
import { useQueryStates } from 'nuqs';
import { GET_ANALYZED_SCENARIO } from '@/graphql/ActionPlanning.queries';
import { SEARCH_PARAMS } from '@/routes/search-params';

export const useQueryGetAnalyzedScenario = (scenarioId: number) => {
  const [{ referenceAreaType, emissionFactorSource, includeNewConstruction }] = useQueryStates(
    SEARCH_PARAMS.actionPlanning.scenario,
  );

  const { data, loading } = useQuery(GET_ANALYZED_SCENARIO, {
    skip: Number.isNaN(scenarioId),
    variables: {
      scenario_id: scenarioId,
      referenceAreaType: referenceAreaType ?? undefined,
      emission_factor_source: emissionFactorSource,
      includeNewConstruction,
    },
    fetchPolicy: 'cache-and-network',
  });

  return {
    analyzedScenario: data?.getAnalyzedScenario,
    isLoadingAnalyzedScenario: loading,
  };
};
